import { apiCall } from '@/util/apiCall'
import type { Languages } from '@common/types/config/Languages'
import { setConfigLanguages } from '../config'
import { makeLoader } from './load'

export const loadLanguages = makeLoader({
	id: 'languages',
	loader: async api => {
		const languages = await apiCall<Languages>(
			'/valkyrie/config/languages',
			{
				signal: api.signal,
			},
		)
		return setConfigLanguages(languages)
	},
})
